<template>
	<div>
		<!-- 子路由出口：需求详情 / 邀请列表等子页面 -->
		<router-view v-if="$route.path.includes('demanDatails') || $route.path.includes('demanYaoqing')"></router-view>
		<div v-else>
			<el-carousel trigger="click">
				<el-carousel-item v-for="item in 1" :key="item">
				   <img src="@/assets/homeimglist.png" alt="" srcset="" class="bannerlist" />
				</el-carousel-item>
			</el-carousel>
			<div class="sobox">
				<div class="soso">
				   <div class="soinput">
					   <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
				   </div>
				   <button @click="sousuo">搜索</button>
				</div>
			</div>
			<div class="demanNav">
				<ul>
					<li @click="qiehuan(1)" :class="{'canshu':navnumber==1}">
						<img src="@/assets/nav11.png" alt="" srcset="" v-if="navnumber==1"/>
						<img src="@/assets/nav1.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav1_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.pass_count}}</span>
								<p>报价中</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(0)" :class="{'canshu':navnumber==0}">
						<img src="@/assets/nav21.png" alt="" srcset=""  v-if="navnumber==0"/>
						<img src="@/assets/nav2.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav2_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.audit_count}}</span>
								<p>审核中</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(2)" :class="{'canshu':navnumber==2}">
						<img src="@/assets/nav31.png" alt="" srcset=""  v-if="navnumber==2"/>
						<img src="@/assets/nav3.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav3_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.end_count}}</span>
								<p>已结束</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(-1)" :class="{'canshu':navnumber==-1}">
						<img src="@/assets/nav41.png" alt="" srcset=""  v-if="navnumber==-1"/>
						<img src="@/assets/nav4.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav4_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.reject_count}}</span>
								<p>已驳回</p>
							</div>
						</div>
					</li>
					<li  @click="qiehuan(5)" :class="{'canshu':navnumber==5}">
						<img src="@/assets/nav51.png" alt="" srcset=""  v-if="navnumber==5"/>
						<img src="@/assets/nav5.png" alt="" srcset=""  v-else/>
						<div class="demanNav1">
							<img src="@/assets/nav5_1.png" alt="" srcset="" />
							<div>
								<span>{{datails.total_count}}</span>
								<p>全部需求</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<demandList :list="list"></demandList>
			<div class="fenye" v-if="total>9">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 :page-count="pagecount"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>

	import { DemandIndex } from '@/api/api'
	
	import demandList from '@/common/demandList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		demandList  
	  },
	  data() {
	    return {
			  currentPage1:"",
			  navnumber:1,
			  keyword:"",
			  page:1,
			  status:"1",
			  list:"",
			  total:"",
			  pagecount:"",
			  datails:''
	    }
	  },
	  created() {
	  	this.getDemandIndex()
	  },
	  watch: {
	    // 从子页（详情/邀请）返回时刷新列表
	    '$route'(to) {
	      const isIndex = to.path === '/demandHome/demandIndex' || to.path === '/demandHome/demandIndex/'
	      if (isIndex) {
	        this.getDemandIndex()
	      }
	    }
	  },
	  methods: {
		handleCurrentChange(e){
			this.page=e
			this.getDemandIndex()
		},
		getDemandIndex(){
			DemandIndex({
				status:this.status,
				keyword:this.keyword,
				page:this.page,
				limit:"9"
			}).then(res=>{
				this.total=res.data.data.total
				this.datails=res.data.data
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.list=res.data.data.data
			})
		},
		sousuo(){
			this.page=1
			this.getDemandIndex()
		},
		qiehuan(type){
			this.page=1
			if(type !=5){
				this.navnumber=type
				this.status=type
			}else{
				this.navnumber=type
				this.status=''
			}
			this.getDemandIndex()
		}
	  },
	}
</script>

<style scoped>
	.bannerlist{
		width:100%;
		min-height:100%;
	}
	.sobox{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
		padding:24px 0px;
	}
	.soso{
		width:792px;
		height:52px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding:10px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items:center;
	}
	.soso button{
		width: 60px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: rgba(255,255,255,0.9);
	    border: none;
	}
	.soinput input{
		width:670px;
		border:none;
		outline:none;
		font-weight: 400;
		font-size: 14px;
	}
	.demanNav{
		width:1200px;
		margin: 0 auto;
	}
	.demanNav ul{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.demanNav li{
		width:220px;
		height:80px;
		position:relative;
		border-radius: 12px 12px 12px 12px;
		cursor:pointer;
	} 
	.canshu{
		box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.2);
	}
	.demanNav li>img{
		width:100%;
		height:100%;
	}
	.demanNav1{
		width:100%;
		height:100%;
		position:absolute;
		top: 0;
		left: 0;
		padding:18px 20px;
		box-sizing: border-box;
		display:flex;
		align-items: center;
	}
	.demanNav1 img{
		width:42px;
		height:42px;
		margin-right:10px;
	}
	.demanNav1 span{
		font-weight: 800;
		font-size: 19px;
		color: #FFFFFF;
	}
	.demanNav1 p{
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.fenye{
		width:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding-bottom:20px;
	}
</style>